import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordScreen } from '@/components/auth/reset-password-screen'

/**
 * `?token=` — the emailed reset token.
 *
 * Left as a raw string here on purpose. The API base64-encodes it into the URL
 * unescaped, so it needs `decodeResetToken` before it means anything, and that
 * decode reports its own failure modes to the screen (expired, already used,
 * mangled in transit). Rejecting a malformed token at the route boundary would
 * turn every one of those into the same blank 404.
 */
export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): { token?: string } =>
    typeof search.token === 'string' ? { token: search.token } : {},
  head: () => ({ meta: [{ title: 'Choose a new password — Constellation QR' }] }),
  component: ResetPasswordScreen,
})
